import GLOBAL from "../../../../setup/constants/global";

export const tenancyType = {
  [GLOBAL.TENANCY_TYPE.RENT]: "Rent",
  [GLOBAL.TENANCY_TYPE.OWN]: "Own",
};
